import { Link } from 'react-router-dom';
import { profile } from '../lib/profile';
import './Footer.css';

export default function Footer() {
  const links = [
    ['vulns', '/vulns'],
    ['github', profile.links.github],
    ['linkedin', profile.links.linkedin],
    ['email', `mailto:${profile.email}`],
    ['rss', '/rss.xml'],
  ];
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__links">
          {links.map(([label, href], i) => (
            <span key={label}>
              {i > 0 && <span className="footer__sep" aria-hidden="true">/</span>}
              {href.startsWith('/') ? (
                <Link to={href}>{label}</Link>
              ) : (
                <a href={href} {...(href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                  {label}
                </a>
              )}
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
}
